export const canCommunityManagerAccess = (pathname: string) =>
  /^\/dashboard\/(users|user|customers|customer|outreach|coupons|coupon)(\/|$)/.test(
    pathname
  );
